import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getAnnouncementType = createAsyncThunk('/getAnnouncementType',
  async () => {
    const response = await axios.get('/GetAnnouncementType');
    return response.data;
});
export const setAnnouncements = createAsyncThunk('/setAnnouncements', async (req) => {
  const response = await axios.post(`/SetAnnouncements`, req);
  return response.data;
});

export const getAnnouncements = createAsyncThunk('/getAnnouncements', async () => {
  const response = await axios.get('/GetAnnouncements');
  return response.data;
});

export const getAnnouncementDetails = createAsyncThunk('/getAnnouncementDetails', async (announcementId) => {
  const response = await axios.get(`/GetAnnouncementDetails/${announcementId}`);
  return response.data;
});

const announcementSlice = createSlice({
  name: 'announcement',
  initialState: {
    loading: false,
    error: '',
    AnnouncementType:[],
    AnnouncementData:[],
    Announcements:[]
  },
  reducers: {
  },
  extraReducers: {  
    [getAnnouncementType.pending]: (state) => {
      state.loading = true;
    },
    [getAnnouncementType.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getAnnouncementType.fulfilled]: (state, action) => {
      state.AnnouncementType = action.payload;
      state.loading = false;
    },
    [setAnnouncements.pending]: (state) => {
      state.loading = true;
    },
    [setAnnouncements.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [setAnnouncements.fulfilled]: (state, action) => {
      state.AnnouncementData = action.payload;
      state.loading = false;
    },
    [getAnnouncementDetails.pending]: (state) => {
      state.loading = true;
    },
    [getAnnouncementDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getAnnouncementDetails.fulfilled]: (state, action) => {
      state.AnnouncementData = action.payload;
      state.loading = false;
    },
    [getAnnouncements.pending]: (state) => {
      state.loading = true;
    },
    [getAnnouncements.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getAnnouncements.fulfilled]: (state, action) => {
      state.Announcements = action.payload;
      state.loading = false;
    }
  }
});
export const announcementActions = announcementSlice.actions;
export default announcementSlice;
